import React from 'react';
import { TYPES, TYPE_LABELS } from '../../lib/driveMedia';

const FolderList = ({ folders, loading, error, onTypeChange, onShowChange }) => {
  if (loading) return <div className="folder-list-status">Loading folders…</div>;
  if (error) return <div className="admin-alert admin-alert--error" role="alert">{error}</div>;
  if (!folders.length) return null;

  return (
    <div className="folder-list" role="table" aria-label="Folders">
      <div className="folder-row folder-row--head" role="row">
        <span role="columnheader">Show</span>
        <span role="columnheader">Folder</span>
        <span role="columnheader">Type</span>
      </div>
      {folders.map(folder => (
        <div key={folder.id} className={`folder-row${folder.show ? '' : ' is-hidden'}`} role="row">
          <span role="cell">
            <input
              type="checkbox"
              aria-label={`Show ${folder.name}`}
              checked={folder.show}
              onChange={event => onShowChange(folder.id, event.target.checked)}
            />
          </span>
          <span className="folder-info" role="cell">
            <span className="folder-name">{folder.name}</span>
            <span className="folder-summary">{folder.summary}</span>
          </span>
          <span role="cell">
            <select
              aria-label={`Show ${folder.name} as`}
              value={folder.type}
              disabled={!folder.show}
              onChange={event => onTypeChange(folder.id, event.target.value)}
            >
              {TYPES.map(type => (
                <option key={type} value={type}>{TYPE_LABELS[type]}</option>
              ))}
            </select>
          </span>
        </div>
      ))}
    </div>
  );
};

export default FolderList;
